import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

import Filter from './Filter';
import {catchQueryFilters} from "./filters_utils";

import './filters.scss';

const Filters = function (
    {
        filter_columns,
        query_divider = '~'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const column_keys = filter_columns.map(column => column.key);
    const filters = catchQueryFilters().filter(filter => column_keys.includes(filter.column));
    const selectedColumns = filters.map(filter => filter.column);

    return (
        <div className="filters">
            <button onClick={() => {
                const index = filters.length;
                searchParams.set('column' + query_divider + index, filter_columns[0].key);
                searchParams.set('expression' + query_divider + index, filter_columns[0].expressions[0]);
                searchParams.set('value' + query_divider + index, filter_columns[0].default ? filter_columns[0].default : '');
                setSearchParams(searchParams);
            }} className='add-filter-button'>
                <i className='fas fa-plus'/>
                <span>Filter</span>
            </button>
            {filters.map((filter, index) => {
                return (
                    <Filter
                        key={index}
                        index={index}
                        filter={filter}
                        columns={filter_columns}
                        selectedColumns={selectedColumns}
                        query_divider={query_divider}
                    />
                )
            })}
        </div>
    );
}

Filters.propTypes = {
    filter_columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        expressions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        multiple: PropTypes.bool,
        component: PropTypes.func
    })).isRequired,
    query_divider: PropTypes.string
};

export default Filters;
